import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/ServicesSubmenu.css';

const ServicesSubmenu: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="services-submenu">
      <h2>Our Services</h2>
      <nav>
        <ul>
          <li>
            <Link 
              to="/services/web-development"
              className={isActive('/services/web-development') ? 'active' : ''}
            >
              <i className="fas fa-code"></i>
              <span>Web Development</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/services/responsive-design"
              className={isActive('/services/responsive-design') ? 'active' : ''}
            >
              <i className="fas fa-mobile-alt"></i>
              <span>Responsive Design</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/services/ecommerce-solutions"
              className={isActive('/services/ecommerce-solutions') ? 'active' : ''}
            >
              <i className="fas fa-shopping-cart"></i>
              <span>E-commerce Solutions</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/services/web-development#maintenance"
              className={location.hash === '#maintenance' ? 'active' : ''}
            >
              <i className="fas fa-server"></i>
              <span>Website Maintenance</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default ServicesSubmenu; 